module.exports = __webpack_public_path__ + "static/bowbooties-f2ccbed39dace07e4981fc0d704f34d4.jpeg";